import React from 'react';
import { TextField } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from 'src/components/sharedComponents/CustomButtons/Button';

const SaveMapValueModal = ({
  save,
  mapValue,
  handleClose,
  onChangeMapValue,
  handleSaveValueMap,
}) => (
  <>
    <Dialog
      maxWidth="sm"
      fullWidth
      open={save}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Mapa de valor</DialogTitle>
      <DialogContent>
        <DialogContent id="alert-dialog-description" style={{padding: '0px', marginBottom: '12px'}}>
          <DialogContentText style={{ marginBottom: '0px' }}>
            Año
            {' '}
            {mapValue.y}
            - Mes
            {' '}
            {mapValue.m}
            {' '}
            - Dia
            {' '}
            {mapValue.d}
          </DialogContentText>
          <TextField
            id="standard-basic"
            label="Titulo"
            fullWidth
            value={mapValue.titulo}
            onChange={(e) => onChangeMapValue({ titulo: e.target.value })}
          />
          <br />
          <TextField
            id="standard-basic"
            fullWidth
            label="Descripcion"
            value={mapValue.descripcion}
            onChange={(e) => onChangeMapValue({ descripcion: e.target.value || '' })}
          />
        </DialogContent>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSaveValueMap} color="github">
          Guardar
        </Button>
        <Button onClick={handleClose} color="github" autoFocus>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  </>
);

export default SaveMapValueModal;
